import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CheckPermissions, DownloadFile, GetSystemCompanyId } from './Shared';

const ReportJobQuoteSummaryData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [systemCompanyId, setSystemCompanyId] = React.useState(2);
    const [startDate, setStartDate] = React.useState("");
    const [endDate, setEndDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            getSystemCompany();
        } else {
            navigate("/accessdenied")
        }
    }

    const getSystemCompany = async () => {
        var sysCompId = await GetSystemCompanyId();

        if (sysCompId === 0) {
            toast.error("Error getting data!");
        } else {
            setSystemCompanyId(sysCompId);
            setLoading(false);
        }
    }

    const clearError = (e: any) => {
        var error = errors;
        delete error[e.target.name];
        setErrors(error);
    }

    const handleStartDateChange = (e: any) => {
        clearError(e);

        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e: any) => {
        clearError(e);

        setEndDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!startDate) {
            formIsValid = false;
            errorList["startDate"] = "Start Date is required";
        }

        if (!endDate) {
            formIsValid = false;
            errorList["endDate"] = "End Date is required";
        }

        if (startDate && endDate && endDate < startDate) {
            formIsValid = false;
            errorList["startDate"] = "Start Date must be < End Date";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            var url = "/report/JobQuoteSummary/" + startDate + "/" + endDate + "/-1/-1/-1";
            window.open(url, '_blank');
        }
    }

    const exportReport = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportRpt();
        }
    }

    const exportRpt = async () => {
        const apiURL = "ExportJobQuoteSummaryData?StartDate=" + startDate + "&EndDate=" + endDate;
        var filename = systemCompanyId === 3 ? "Job Order Summary.xlsx" : "Job Quote Summary.xlsx";
        await DownloadFile(apiURL, filename);
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Job {systemCompanyId === 3 ? "Order" : "Quote"} Summary Report</h1>
            </div>
            <div className="marginTop20">
                <div>Report showing all {systemCompanyId === 3 ? "orders" : "quotes"} created between start and end dates.</div>
                <span>Select a Start Date and End Date to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="startDate">
                    <span className="label">Start Date</span>
                    <input type='date' id="startDate" name="startDate" className='input' value={startDate} onChange={(e) => handleStartDateChange(e)}></input>
                </label>
                <span className={errors["startDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["startDate"]}</span>

                <label className="input-group" htmlFor="endDate">
                    <span className="label">End Date</span>
                    <input type='date' id="endDate" name="endDate" className='input' value={endDate} onChange={(e) => handleEndDateChange(e)}></input>
                </label>
                <span className={errors["endDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["endDate"]}</span> 
            </div>
            <button className="defaultbutton marginLeftLabel marginRight10" type='button' onClick={runReport}>Run Report</button>
            <button className="defaultbutton" type='button' onClick={exportReport}>Export to Excel</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            {contents}
        </div>
    )

};

export default ReportJobQuoteSummaryData;